#import "../../PayCyclePaymentsFragment.graphql"
#import "../../../../common/graphql/EntityDocumentsFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query AccountingEntryPayCycle($id: UUID!) {
  payCycle(id: $id) {
    id
    _documentPackageId
    _rowTimestamp
    _isAccountingEntry
    _isHistory
    _isUpdatable
    _isApprovalRevocable
    _isProtected
    corporatePeriodId
    defaultPaymentDate
    controlTotalAmount
    description
    _accountingStampDate
    _accountingStampUserId
    _accountingStampUserName
    _accountingStampTransactionReference
    _isTransactionCancelled
    _isAccountingEntryStampedComplete
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    companyCorporatePeriod {
      id
      _periodYear
      startDate
      endDate
    }
    paymentAccount {
      id
      name
      bankAccountNumber
      currency {
        id
        isoCode
        name
      }
    }
    transactionType {
      description
      layoutType
      transactionType
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    payCycleHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    isDraft
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    payments {
      ...PayCyclePaymentsFragment
    }
     _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
